module.exports = __webpack_public_path__ + "static/media/video-gallery.6d2cc49e.png";